import { useEffect, useState } from 'react'

/** enter: mark entrance, field static. ripple: field ripples once. idle: field breathes. */
export type LaunchPhase = 'enter' | 'ripple' | 'idle'

const prefersReducedMotion = () =>
  typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches

/** Welcome page launch timeline (plan C5): ripple at 300ms, breathe from 2000ms. */
export const useLaunchChoreography = (): LaunchPhase => {
  const [phase, setPhase] = useState<LaunchPhase>(() => (prefersReducedMotion() ? 'idle' : 'enter'))

  useEffect(() => {
    if (phase === 'idle') return
    const ripple = setTimeout(() => setPhase('ripple'), 300)
    const settle = setTimeout(() => setPhase('idle'), 2000)
    return () => {
      clearTimeout(ripple)
      clearTimeout(settle)
    }
  }, [])

  return phase
}
